export default __webpack_public_path__ + "static/media/92.6ee9dc47.png";